import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next';

export const mutateAdResume = (initParams) => {
    // Status messages in the user's language, not the server's English text.
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationKey: ['ad-resume', initParams],
        mutationFn: async () => {
            const res = await axios.put(route('studio.v1.api.ads.resume', initParams?.id));
            return res;
        },
        onSuccess: async ({ data }) => {

            notifications.show({
                color: 'green',
                title: t('ads.toast.resumed'),
            })

        },
        onError: async ({ response }) => {

            notifications.show({
                color: 'red',
                title: t('common.error'),
                message: response?.data?.message || "",
            })
        }
    });

    return mutation;
}
